// extracted by mini-css-extract-plugin
export default {"btnLink":"CountDown_btnLink__+2sZR","messageCounter":"CountDown_messageCounter__fZETp"};